import React from 'react'
import { Outlet } from 'react-router-dom'

const RuleChain = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default RuleChain
